import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const SITE_KEY = "6LfoD0ssAAAAAOTMJ9r6RyMlh0WDakIg6mxMJrM5";

export default function RecaptchaWrapper({ children }) {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={SITE_KEY}
      scriptProps={{
        async: true,
        defer: true,
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
}
